import type { VuetifyOptions } from 'vuetify'
import { useThemeConfig } from '@/composable/useThemeConfig'
import { brandColours } from './brandColours'

const { defaultTheme } = useThemeConfig()

const theme: VuetifyOptions['theme'] = {
  defaultTheme: defaultTheme.value,
  variations: {
    colors: ['primary', 'secondary', 'info'],
    lighten: 3,
    darken: 3,
  },
  themes: {
    light: {
      dark: false,
      colors: {
        'primary': '#56bbaf',
        'primary-light': '#f2fbf9', // primary-50
        'primary-dark': '#2E736B', // primary-700
        'on-primary': '#fff',
        'secondary': '#cc4584',
        'on-secondary': '#fff',
        'tertiary': '#7A93A4',
        'on-tertiary': '#fff',
        'brand-eirquest': brandColours.eirquest,
        'brand-cymruquest': brandColours.cymruquest,
        'brand-turquest': brandColours.mycareerchoices,
        'brand-myaptitude': brandColours.myaptitude,
        'brand-myaptitudecore': brandColours.myaptitudecore,
        'brand-mycareerchoices': brandColours.mycareerchoices,
        'brand-myfirstchoices': brandColours.myfirstchoices,
        'brand-myunichoices': brandColours.myunichoices,
        'brand-completesuite': brandColours.completesuite,
        'success': '#4BBF73',
        'success-light': '#81d29d',
        'success-background': '#b5ecc4',
        'success-dark': '#3c995c',
        'on-success': '#fff',
        'info': '#1F9BCF',
        'on-info': '#fff',
        'warning': '#E5A54B',
        'warning-light': '#f2d2a4',
        'on-warning': '#fff',
        'error': '#D9534F',
        'background': '#EDF1F5',
        'background-dark': '#D5D9DD',
        'on-background': '#365260',
        'on-surface': '#365260',
        'grey-50': '#FAFAFA',
        'grey-100': '#F5F5F5',
        'grey-200': '#EEEEEE',
        'grey-300': '#E0E0E0',
        'grey-400': '#BDBDBD',
        'grey-500': '#9E9E9E',
        'grey-600': '#757575',
        'grey-700': '#616161',
        'grey-800': '#424242',
        'grey-900': '#212121',
        'in-card': '#EEEEEE',
        'perfect-scrollbar-thumb': '#DBDADE',
      },

      variables: {
        'border-color': '#4B465C',
        'medium-emphasis-opacity': 0.68,

        // Shadows
        'shadow-key-umbra-opacity': 'rgba(var(--v-theme-on-surface), 0.03)',
        'shadow-key-penumbra-opacity': 'rgba(var(--v-theme-on-surface), 0.02)',
        'shadow-key-ambient-opacity': 'rgba(var(--v-theme-on-surface), 0.01)',
      },
    },
    dark: {
      dark: true,
      colors: {
        'primary': '#7367F0',
        'primary-light': '#2E736B', // primary-700
        'primary-dark': '#f2fbf9', // primary-50
        'on-primary': '#fff',
        'secondary': '#cc4584',
        'on-secondary': '#fff',
        'tertiary': '#7A93A4',
        'on-tertiary': '#fff',
        'brand-eirquest': brandColours.eirquest,
        'brand-cymruquest': brandColours.cymruquest,
        'brand-turquest': brandColours.mycareerchoices,
        'brand-myaptitude': brandColours.myaptitude,
        'brand-myaptitudecore': brandColours.myaptitudecore,
        'brand-mycareerchoices': brandColours.mycareerchoices,
        'brand-myfirstchoices': brandColours.myfirstchoices,
        'brand-myunichoices': brandColours.myunichoices,
        'brand-completesuite': brandColours.completesuite,
        'success': '#28C76F',
        'success-light': '#81d29d',
        'success-background': '#13301c',
        'success-dark': '#3c995c',
        'on-success': '#fff',
        'info': '#00CFE8',
        'on-info': '#fff',
        'warning': '#FF9F43',
        'on-warning': '#fff',
        'error': '#EA5455',
        'background': '#25293C',
        'background-dark': '#1E2130',
        'on-background': '#E4E6F4',
        'surface': '#2F3349',
        'on-surface': '#E4E6F4',
        'grey-50': '#26293A',
        'grey-100': '#252839',
        'grey-200': '#32364c',
        'grey-300': '#4A5072',
        'grey-400': '#5E6692',
        'grey-500': '#7983BB',
        'grey-600': '#AAB3DE',
        'grey-700': '#B6BEE3',
        'grey-800': '#CFD3EC',
        'grey-900': '#E7E9F6',
        'in-card': '#B4B8CC',
        'perfect-scrollbar-thumb': '#4A5072',
      },
      variables: {
        'border-color': '#CFD3EC',
        'medium-emphasis-opacity': 0.68,

        // Shadows
        'shadow-key-umbra-opacity': 'rgba(12, 16, 27, 0.15)',
        'shadow-key-penumbra-opacity': 'rgba(12, 16, 27, 0.01)',
        'shadow-key-ambient-opacity': 'rgba(12, 16, 27, 0.08)',
      },
    },
  },
}

export default theme
